/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
import * as i0 from '@angular/core';
import * as i1 from '@angular/common';
import * as i2 from '@angular/router';
import * as i3 from '../../../../../src/app/components/menu/menu.component';
import * as i4 from '../../../../../src/app/services/common.service';
import * as i5 from '../../../../../src/app/services/shared.service';
var styles_MenuComponent = [];
export var RenderType_MenuComponent = i0.ɵcrt({ encapsulation: 2,
    styles: styles_MenuComponent, data: {} });
function View_MenuComponent_3(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 6, 'li', [], null, null, null, null, null)), i0.ɵdid(278528, null, 0, i1.NgClass, [i0.IterableDiffers, i0.KeyValueDiffers, i0.ElementRef,
            i0.Renderer], { ngClass: [0, 'ngClass'] }, null), (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵeld(0, null, null, 2, 'a', [], [[1, 'target', 0], [8, 'href', 4]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (i0.ɵnov(_v, 4).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            if (('click' === en)) {
                var pd_1 = (_co.clickMenu(_v.context.$implicit) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(671744, null, 0, i2.RouterLinkWithHref, [i2.Router, i2.ActivatedRoute, i1.LocationStrategy], { routerLink: [0, 'routerLink'] }, null), (_l()(), i0.ɵted(null, ['\n                        ', '\n                    '])),
        (_l()(), i0.ɵted(null, ['\n                ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.getClasses(_v.parent.context.$implicit);
        _ck(_v, 1, 0, currVal_0);
        var currVal_3 = _v.context.$implicit.url;
        _ck(_v, 4, 0, currVal_3);
    }, function (_ck, _v) {
        var currVal_1 = i0.ɵnov(_v, 4).target;
        var currVal_2 = i0.ɵnov(_v, 4).href;
        _ck(_v, 3, 0, currVal_1, currVal_2);
        var currVal_4 = _v.context.$implicit.descripcion;
        _ck(_v, 5, 0, currVal_4);
    });
}
function View_MenuComponent_2(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 18, 'li', [], null, null, null, null, null)), i0.ɵdid(278528, null, 0, i1.NgClass, [i0.IterableDiffers, i0.KeyValueDiffers, i0.ElementRef,
            i0.Renderer], { ngClass: [0, 'ngClass'] }, null), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵeld(0, null, null, 8, 'a', [], [[1, 'target', 0], [8, 'href', 4]], [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (i0.ɵnov(_v, 4).onClick($event.button, $event.ctrlKey, $event.metaKey, $event.shiftKey) !== false);
                ad = (pd_0 && ad);
            }
            if (('click' === en)) {
                var pd_1 = (_co.clickMenu(_v.context.$implicit) !== false);
                ad = (pd_1 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(671744, null, 0, i2.RouterLinkWithHref, [i2.Router, i2.ActivatedRoute, i1.LocationStrategy], { routerLink: [0, 'routerLink'] }, null), (_l()(), i0.ɵted(null, ['\n                '])), (_l()(),
            i0.ɵeld(0, null, null, 1, 'span', [], null, null, null, null, null)), i0.ɵdid(278528, null, 0, i1.NgClass, [i0.IterableDiffers, i0.KeyValueDiffers, i0.ElementRef, i0.Renderer], { ngClass: [0, 'ngClass'] }, null), (_l()(), i0.ɵted(null, ['\n                '])),
        (_l()(), i0.ɵeld(0, null, null, 1, 'span', [['class', 'list-group-item-value']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['', ''])), (_l()(), i0.ɵted(null, ['\n            '])),
        (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵeld(0, null, null, 4, 'ul', [['class', 'main-menu list-group estiloChild']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_MenuComponent_3)), i0.ɵdid(802816, null, 0, i1.NgForOf, [i0.ViewContainerRef, i0.TemplateRef, i0.IterableDiffers], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(),
            i0.ɵted(null, ['\n        ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.getClasses(_v.context.$implicit);
        _ck(_v, 1, 0, currVal_0);
        var currVal_3 = (_v.context.$implicit.url ? _v.context.$implicit.url : '');
        _ck(_v, 4, 0, currVal_3);
        var currVal_4 = _co.getMenuIcon(_v.context.$implicit.icono);
        _ck(_v, 7, 0, currVal_4);
        var currVal_6 = _v.context.$implicit.child;
        _ck(_v, 16, 0, currVal_6);
    }, function (_ck, _v) {
        var currVal_1 = i0.ɵnov(_v, 4).target;
        var currVal_2 = i0.ɵnov(_v, 4).href;
        _ck(_v, 3, 0, currVal_1, currVal_2);
        var currVal_5 = _v.context.$implicit.descripcion;
        _ck(_v, 10, 0, currVal_5);
    });
}
function View_MenuComponent_1(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 4, 'ul', [['class',
                'main-menu list-group ajusteAltoMenu']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n        '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_MenuComponent_2)),
        i0.ɵdid(802816, null, 0, i1.NgForOf, [i0.ViewContainerRef, i0.TemplateRef,
            i0.IterableDiffers], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), i0.ɵted(null, ['\n    ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.menus;
        _ck(_v, 3, 0, currVal_0);
    }, null);
}
export function View_MenuComponent_0(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 4, 'div', [['class',
                'nav-pf-vertical nav-pf-vertical-with-secondary-nav']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n    '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_MenuComponent_1)),
        i0.ɵdid(16384, null, 0, i1.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n'])), (_l()(), i0.ɵted(null, ['\n']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.menus;
        _ck(_v, 3, 0, currVal_0);
    }, null);
}
export function View_MenuComponent_Host_0(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 1, 'menu', [], null, null, null, View_MenuComponent_0, RenderType_MenuComponent)),
        i0.ɵdid(114688, null, 0, i3.MenuComponent, [i4.CommonService, i5.SharedService,
            i2.Router], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
export var MenuComponentNgFactory = i0.ɵccf('menu', i3.MenuComponent, View_MenuComponent_Host_0, {}, { menuChange: 'menuChange' }, []);
//# sourceMappingURL=menu.component.ngfactory.js.map